import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/styles/makeStyles';
import InfoIcon from '@material-ui/icons/Info';
import classNames from 'classnames';
import { blackColor } from 'assets/jss/material-dashboard-pro-react';
import InfoLink from 'components/InfoLink/InfoLink';
import { type ReactNode } from 'react';

const SIZES = {
  s: 's',
  m: 'm',
} as const;

const useStyles = (size: keyof typeof SIZES) =>
  makeStyles({
    tooltip: {
      width: `${size === SIZES.s ? 240 : 300}px`,
    },
    title: {
      display: 'grid',
      gap: '4px',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      width: 'fit-content',
      padding: '2px 0',
      color: 'inherit',
      fontSize: 'inherit',
      fontWeight: '500',
      pointerEvents: 'all',
      textDecoration: 'underline',
      '&:hover': {
        color: 'inherit',
        textDecoration: 'underline',
      },
    },
    openInNewIcon: {
      fontSize: '16px',
    },
    infoIcon: {
      fill: blackColor,
      opacity: '0.46',
    },
  })();

type InfoWithTooltipProps = {
  link: string;
  linkText?: string;
  title: ReactNode;
  className?: string;
  size?: keyof typeof SIZES;
};

const InfoWithTooltip = ({
  link,
  linkText,
  title,
  className,
  size = SIZES.m,
}: InfoWithTooltipProps) => {
  const classes = useStyles(size);

  return (
    <Tooltip
      classes={{
        tooltip: classes.tooltip,
      }}
      interactive={true}
      title={
        <div className={classes.title}>
          {title && <div>{title}</div>}
          <InfoLink link={link} text={linkText} />
        </div>
      }
    >
      <InfoIcon
        className={classNames(classes.infoIcon, className)}
        fontSize="small"
      />
    </Tooltip>
  );
};

export default InfoWithTooltip;
